/**
 * @ngdoc service
 * @name proximus.core.entity:$entityFactory
 * @requires EntityConfig
 * @description
 * # $entityFactory
 *  Creates entity objects based on their configuration.
 */
//Note: this was a provider, and we were able to change defaultEntityConfig only at config phase
export default class EntityFactory {
    constructor(entityIdentifier, configurationService) {
        this.entityIdentifier = entityIdentifier;
        this.configurationService = configurationService;
    }
    // Note: default entity configuration had hardcoded defaults and could be provided at cofig phase, now it should be provided in configuration
    // If we provide defaults - should we also give the ability to provide the default storage strategy?
    /**
     * creates new entity for provided entity configuration and parameters
     * @memberof proximus.core.entity:$entityManager
     * @param {EntityConfig} configuratio of entity
     * @param {Map} parameters to create entity URL.
     * Parameters must be passed in the order they should appear in the URL placeholders.
     * @returns {Entity} entity
     */
    createEntity(entityConfig, parameterMap) {
        const entity = Object.assign({}, this.configurationService.getDefaultEntityConfiguration(), entityConfig);
        if (entityConfig.requestHeaders) {
            entity.requestHeaders = entityConfig.requestHeaders;
        }
        if (entity.url) {
            entity.url = this.entityIdentifier.replaceUrlPlaceholders(entity.url, parameterMap);
        }
        entity.parameters = parameterMap;
        entity.value = '';
        entity.etag = '';
        entity.expires = '';
        entity.headers = [];
        entity.identifier = this.entityIdentifier.getEntityIdentifier(entity);
        entity.uniqueKey = this.entityIdentifier.getUniqueKey(entity);
        return entity;
    }
}
